export const oneNoteAppName = "KAa";
export const communities = "LAa";
export default {oneNoteAppName,communities};